import ApiService from '@/core/api/api.service';
import store from '@/store';

import { FePreferenceService } from '@/core/fe-preferences';
import { VendorUserService } from '@/core/vendor-user';

import { functionsWithNotifications } from '@/core/notifications';
import workerMessages from './worker.messages';
import Worker from './worker.mapper';

const functions = {
  createForUser,
  get,
  completeRegistration,
  inviteAssistance,
};

const workerOnBoardingFePreferenceKey = `next-${GLOBALS.APP}--worker-on-boarding`;

export default {
  ...functionsWithNotifications(functions, workerMessages),
  getWorkerOnBoardingFePreferenceKey: () => workerOnBoardingFePreferenceKey,
};

const workerApi = new ApiService();

async function createForUser(userUuid, worker) {
  const requestBody = {
    worker: {
      mobile_phone_number: _.get(worker, 'mobile_phone_number', ''),
    },
  };
  const response = await workerApi.post(`users/${userUuid}/workers`, requestBody);
  const newWorker = new Worker(response.data.data);
  store.commit('setWorker', newWorker);

  await VendorUserService.clearCache();
  await VendorUserService.get(userUuid);
  return newWorker;
}

async function get(workerUuid) {
  const response = await workerApi.get(`workers/${workerUuid}`);
  const worker = new Worker(response.data.data);
  store.commit('setWorker', worker);
  return worker;
}

async function completeRegistration(workerUuid, params) {
  const requestBody = {
    complete_registration: {
      client_uuid: _.get(params, 'client_uuid'),
      trading_name: _.get(params, 'trading_name'),
      business_number: _.get(params, 'business_number', ''),
    },
  };
  await workerApi.post(`workers/${workerUuid}/complete_registrations`, requestBody);
  await FePreferenceService.save(workerOnBoardingFePreferenceKey, {
    complete_registration: true,
  });
}

async function inviteAssistance(workerUuid, params) {
  const requestBody = {
    invitation_assistance: {
      email_address: _.get(params, 'email_address'),
      client_uuid: _.get(params, 'client_uuid'),
      trading_name: _.get(params, 'trading_name'),
      business_number: _.get(params, 'business_number', ''),
    },
  };
  await workerApi.post(`workers/${workerUuid}/invitation_assistances`, requestBody);
}
